<template lang="pug">
  v-container.geodis-add-component(style="width: 100%")
    v-row.mb-2.grey.lighten-3(style="border-radius: 3px")
      v-col
        h1 Components
        p.grey--text.text--darken-1 Click on your component and set it up before adding it to the form.
    v-row.grey.lighten-3(wrap, style="border-radius: 3px")
      v-col(cols="12", sm="6", md="4", lg="2", v-if="hasFieldType('string')")
        v-dialog(v-model="dialog['text']", max-width="800")
          template(v-slot:activator="{ on }")
            .component.text-center(@click="initField($event, on, 'string', 'text')")
              h4.component__name Text
              .component__field
                v-text-field(label="Field", disabled, hide-details)
              v-icon.component__active(color="green", v-if="alias === 'text' && saved") mdi-check-circle
          v-card
            v-card-text
              app-create-field(
                v-model="field.text",
                :items="filterFields(['string', 'number', 'int'])"
              )
            v-card-actions
              v-spacer
              v-btn.mr-2(@click="enableAdd", outlined, color="primary") Save
      v-col(cols="12", sm="6", md="4", lg="2", v-if="hasFieldType('string')")
        v-dialog(v-model="dialog['dropdown']", max-width="800")
          template(v-slot:activator="{ on }")
            .component.text-center(@click="initField($event, on, 'string', 'dropdown')")
              h4.component__name Dropdown
              .component__field
                v-select(label="Field", disabled, hide-details)
              v-icon.component__active(color="green", v-if="alias === 'dropdown' && saved") mdi-check-circle
          v-card
            v-card-text
              app-create-field(
                v-model="field.dropdown",
                :items="filterFields('string')"
              )
            v-card-actions
              v-spacer
              v-btn.mr-2(@click="enableAdd", outlined, color="primary") Save
      v-col(cols="12", sm="6", md="4", lg="2", v-if="hasFieldType('datetime')")
        v-dialog(v-model="dialog['date']", max-width="800")
          template(v-slot:activator="{ on }")
            .component.text-center(@click="initField($event, on, 'datetime', 'date')")
              h4.component__name Date
              .component__field
                v-text-field(label="Field", prepend-icon="mdi-calendar", disabled, hide-details)
              v-icon.component__active(color="green", v-if="alias === 'date' && saved") mdi-check-circle
          v-card
            v-card-text
              app-create-field(
                v-model="field.date",
                :items="filterFields('datetime')"
              )
            v-card-actions
              v-spacer
              v-btn.mr-2(@click="enableAdd", outlined, color="primary") Save
      v-col(cols="12", sm="6", md="4", lg="2", v-if="hasFieldType('datetime')")
        v-dialog(v-model="dialog['time']", max-width="800")
          template(v-slot:activator="{ on }")
            .component.text-center(@click="initField($event, on, 'datetime', 'time')")
              h4.component__name Time
              .component__field
                v-text-field(label="Field", prepend-icon="mdi-clock", disabled, hide-details)
              v-icon.component__active(color="green", v-if="alias === 'time' && saved") mdi-check-circle
          v-card
            v-card-text
              app-create-field(
                v-model="field.time",
                :items="filterFields('datetime')"
              )
            v-card-actions
              v-spacer
              v-btn.mr-2(@click="enableAdd", outlined, color="primary") Save
      v-col(cols="6", sm="3", md="2", lg="1", v-if="hasFieldType('boolean')")
        v-dialog(v-model="dialog['checkbox']", max-width="800")
          template(v-slot:activator="{ on }")
            .component.text-center(@click="initField($event, on, 'boolean', 'checkbox')")
              h4.component__name Checkbox
              .component__field
                v-checkbox(disabled, hide-details)
              v-icon.component__active(color="green", v-if="alias === 'checkbox' && saved") mdi-check-circle
          v-card
            v-card-text
              app-create-field(
                v-model="field.checkbox",
                :items="filterFields('boolean')"
              )
            v-card-actions
              v-spacer
              v-btn.mr-2(@click="enableAdd", outlined, color="primary") Save
      v-col(cols="6", sm="3", md="2", lg="1", v-if="hasFieldType('string')")
        v-dialog(v-model="dialog['radio']", max-width="800")
          template(v-slot:activator="{ on }")
            .component.text-center(@click="initField($event, on, 'string', 'radio')")
              h4.component__name Radio
              .component__field
                v-radio(disabled, hide-details)
              v-icon.component__active(color="green", v-if="alias === 'radio' && saved") mdi-check-circle
          v-card
            v-card-text
              app-create-field(
                v-model="field.radio",
                :items="filterFields('string')"
              )
            v-card-actions
              v-spacer
              v-btn.mr-2(@click="enableAdd", outlined, color="primary") Save
      v-col.text-center(cols="12", sm="6", md="4", lg="2", align-self="center")
        v-btn(text, color="geoBlue", :disabled="!saved", @click="addField")
          span Add Component
          v-icon(large) mdi-plus-circle
    v-row.my-5.dictionary(justify="center")
      v-col(cols="auto")
        v-icon.pr-2(color="black") mdi-view-column
        span It will appear on the Custom Order Table
      v-col(cols="auto")
        v-icon.pr-2 mdi-view-column
        span It won´t appear on the Custom Order Table
      v-col(cols="auto")
        v-icon.pr-2(color="black") mdi-eye
        span Enabled
      v-col(cols="auto")
        v-icon.pr-2 mdi-eye-off
        span Disabled
      v-col(cols="auto")
        v-icon.pr-2(color="error") mdi-cancel
        span Delete component
    v-row(justify="space-around", style="background-color:#8331f1; color:white; font-weight:bold")
      each n in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        v-col.text-center(cols="auto")
          span= n
</template>

<script>
export default {
  props: {
    fields: Array
  },
  data () {
    return {
      field: {},
      saved: false,
      alias: '',
      dialog: {}
    }
  },
  methods: {
    initField (e, on, type, alias) {
      const field = this.fields.find(f => f.type.toLowerCase().match(type))
      this.saved = false
      this.alias = alias

      if (field) {
        on.click(e)
        this.field[alias] = { ...field, rules: [], name: '', ...this.field[alias] }
      }
    },
    hasFieldType (type) {
      return !!this.fields.find(f => f.type.toLowerCase().match(type))
    },
    addField () {
      if (!this.alias) return
      this.$emit('add-field', this.field[this.alias])
      this.field = {}
      this.saved = false
    },
    filterFields (filter) {
      filter = typeof filter === 'string' ? [filter] : filter
      return this.fields.filter(f => filter.some(_f => f.type.toLowerCase().match(_f)))
    },
    enableAdd () {
      this.dialog = {}
      this.saved = true
    }
  }
}
</script>
